module.exports = __webpack_public_path__ + "img/C08TechVanisGrip_ua.616aa932.webp";